import { render, staticRenderFns } from "./CustomizeCard.vue?vue&type=template&id=4a567aec&scoped=true&"
import script from "./CustomizeCard.vue?vue&type=script&lang=js&"
export * from "./CustomizeCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeCard.vue?vue&type=style&index=0&id=4a567aec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a567aec",
  null
  
)

export default component.exports